import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../AuthContext'
import { Col, Row, Container } from 'react-bootstrap'
import ReactEcharts from 'echarts-for-react'
import Community from '../Fans/Community'
// import data from '../../data/fanValue.json'
import FanGrowth from '../Fans/FanGrowth'
import AITeacher from '../AITeacher'
import { Helmet } from 'react-helmet'
// import { v4 as uuidv4 } from 'uuid'
import GroupSideBar from '../GroupSideBar'
import GroupCommunity from './GroupCommunity'
import GroupFanRanking from './GroupFanRanking'
import axios from 'axios'
import * as dayjs from 'dayjs'
import { useAPI } from '../../hooks/useAPI'

const GroupFans = () => {
  const { currentUser, BaseUrl, setIsLoading, brandArr } =
    useContext(AuthContext)
  const getSubIncorporation = 'incorporation/v1/GetSubIncorporation'
  const getIncLast = 'fanValue/v2/GetIncLast'
  const getLast = 'fanValue/v2/GetLast'

  const today = dayjs().format('YYYY-MM-DD')

  const [companyName, setCompanyName] = useState([
    {
      inc_id: '',
      kol_id: '',
      kol_name: '',
      inc_name: '',
    },
  ])
  const [incLastData, setIncLastData] = useState([
    {
      fans_grow_fb: 0,
      fans_grow_yt: 0,
      fans_accm_30d_yt: 0,
      fans_grow_ig: 0,
      fans_lost_30d_ig: 0,
      kol_name: '',
      fans_lost_30d_fb: 0,
      fans_accm_30d_ig: 0,
      fans_accm_30d_fb: 0,
      fans_lost_30d_yt: 0,
      count_fans: 0,
      kol_id: '',
      fans_grow_community: 0,
      count_yt: 0,
      fans_accm_7d_ig: 0,
      fans_accm_7d_fb: 0,
      count_ig: 0,
      fans_accm_7d_yt: 0,
      count_fb: 0,
    },
  ])
  const [currentCompanyId, setCurrentCompanyId] = useState(null)
  const [currentCompany, setCurrentCompany] = useState(null)
  const [currentCompanyData, setCurrentCompanyData] = useState({
    fans_grow_fb: 0,
    fans_grow_yt: 0,
    fans_accm_30d_yt: 0,
    ai_teacher_comment: '',
    fans_grow_ig: 0,
    fans_lost_30d_ig: 0,
    fans_lost_30d_fb: 0,
    fans_accm_30d_ig: 0,
    fans_accm_30d_fb: 0,
    fans_lost_30d_yt: 0,
    fans_grow_community: 0,
    fans_accm_7d_ig: 0,
    fans_accm_7d_fb: 0,
    fans_accm_7d_yt: 0,
  })

  // 拿到公司列表
  useEffect(() => {
    setIsLoading(true)
    axios
      .get(BaseUrl + getSubIncorporation, {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: '*/*',
          tk: currentUser.tk,
        },
      })
      .then((res) => {
        setIsLoading(false)
        setCompanyName(res.data.data)
      })
      .catch((e) => {
        setIsLoading(false)
        console.log(e)
      })
  }, [])

  // 拿到全公司資料
  const allCompanyRequestBody = { date: today }
  const fetchAllCompanyData = useAPI({
    path: getIncLast,
    requestBody: allCompanyRequestBody,
    initData: incLastData,
    msg: '天神粉絲價值',
    dependencies: [currentCompanyId],
  }).fetchData

  // 拿到全公司資料
  useEffect(() => {
    if (fetchAllCompanyData.data) {
      setIncLastData(fetchAllCompanyData.data)
    }
  }, [fetchAllCompanyData])
  // const [totalFanPercentage, setTotalFanPercentage] = useState({
  //   fb: 0,
  //   ig: 0,
  //   yt: 0,
  // })
  const [totalFBFanPercentage, setTotalFBFanPercentage] = useState(0)
  const [totalIGFanPercentage, setTotalIGFanPercentage] = useState(0)
  const [totalYTFanPercentage, setTotalYTFanPercentage] = useState(0)
  useEffect(() => {
    setTotalFBFanPercentage(
      (
        incLastData.reduce(
          (total, element) => total + element.fans_grow_fb,
          0
        ) / incLastData.length
      ).toFixed(2)
    )
    setTotalIGFanPercentage(
      (
        incLastData.reduce(
          (total, element) => total + element.fans_grow_ig,
          0
        ) / incLastData.length
      ).toFixed(2)
    )
    setTotalYTFanPercentage(
      (
        incLastData.reduce(
          (total, element) => total + element.fans_grow_yt,
          0
        ) / incLastData.length
      ).toFixed(2)
    )
  }, [incLastData])

  // 取得單一公司資料
  const requestBody = { kol_id: currentCompanyId }
  const fetchCurrentCompanyData = useAPI({
    path: getLast,
    requestBody: requestBody,
    initData: currentCompanyData,
    msg: '天神單一公司粉絲價值',
    dependencies: [currentCompanyId, currentCompany],
  }).fetchData

  useEffect(() => {
    if (currentCompany) {
      setCurrentCompanyData(fetchCurrentCompanyData)
    }
  }, [fetchCurrentCompanyData])

  // 當前查看的公司
  useEffect(() => {
    incLastData.forEach((element) => {
      if (currentCompanyId === element.kol_id) {
        setCurrentCompany(element)
      } else if (currentCompanyId === null) {
        setCurrentCompany(null)
      }
    })
  }, [currentCompanyId])

  const [growOption, setgrowOption] = useState({})
  useEffect(() => {
    setgrowOption({
      xAxis: {
        data: ['Facebook', 'Instagram', 'YouTube'],
      },
      yAxis: {
        name: '%',
      },
      legend: {},
      tooltip: { trigger: 'item', formatter: '{b} {c} %' },
      series: [
        {
          type: 'bar',
          data: [
            {
              type: 'bar',
              name: 'Facebook',
              value: !currentCompanyId
                ? totalFBFanPercentage
                : typeof currentCompanyData.fans_grow_fb === 'number'
                ? currentCompanyData.fans_grow_fb
                : 0,
              itemStyle: {
                color: '#4267B2',
              },
            },
            {
              type: 'bar',
              name: 'Instagram',
              value: !currentCompanyId
                ? totalIGFanPercentage
                : typeof currentCompanyData.fans_grow_ig === 'number'
                ? currentCompanyData.fans_grow_ig
                : 0,
              itemStyle: {
                color: '#C13584',
              },
            },
            {
              type: 'bar',
              name: 'YouTube',
              value: !currentCompanyId
                ? totalYTFanPercentage
                : typeof currentCompanyData.fans_grow_yt === 'number'
                ? currentCompanyData.fans_grow_yt
                : 0,
              itemStyle: {
                color: '#FF0000',
              },
            },
          ],
        },
      ],
    })
  }, [
    currentCompanyId,
    currentCompanyData,
    totalFBFanPercentage,
    totalIGFanPercentage,
    totalYTFanPercentage,
  ])

  return (
    <>
      <Helmet>
        <title>粉絲價值 | KOLSTAR</title>
      </Helmet>
      <main className="groupFans d-flex flex-column flex-md-row">
        <Col xs={12} md={3} className={`d-flex flex-column sideBar `}>
          <GroupSideBar
            companyName={companyName}
            setCurrentCompanyId={setCurrentCompanyId}
            currentCompanyId={currentCompanyId}
          />
        </Col>
        {/* 全品牌 */}
        {!currentCompanyId && (
          <Col xs={12} md={9}>
            <Container className="section1">
              <Row className="d-flex flex-column-reverse flex-xl-row">
                <Col
                  xs={12}
                  xl={5}
                  className="flex-grow-1 text-nowrap overflowX my-auto"
                >
                  <GroupCommunity
                    totalFBFanPercentage={totalFBFanPercentage}
                    totalIGFanPercentage={totalIGFanPercentage}
                    totalYTFanPercentage={totalYTFanPercentage}
                  />
                </Col>
                <Col xl={4} className="mx-xl-3 px-xl-3 order-md-1 m-auto">
                  <ReactEcharts
                    style={{ width: '100%', height: '300px' }}
                    className="w-100"
                    option={growOption}
                  />
                </Col>
              </Row>
            </Container>
            <Container className="section2">
              <GroupFanRanking
                incLastData={incLastData}
                setIncLastData={setIncLastData}
                title="個別品牌粉絲績效排行"
              />
            </Container>
          </Col>
        )}
        {/* =============================== 各品牌 =============================== */}
        {currentCompany && (
          <Col xs={12} md={9}>
            <Container className="section1">
              <h3 className="fw-bold mt-4 mx-3 d-md-none">
                {currentCompany.kol_name}
              </h3>
              <Row className="d-flex flex-column-reverse flex-md-row mx-2">
                <Col
                  xs={12}
                  md={5}
                  className="flex-grow-1 text-nowrap overflowX my-auto"
                >
                  <h3 className="fw-bold mt-4 d-none d-md-block">
                    {currentCompany.kol_name}
                  </h3>
                  <Community data={currentCompanyData} brandArr={brandArr} />
                </Col>
                <Col md={4} className="mx-lg-3 px-lg-3 order-md-1 m-auto">
                  <ReactEcharts
                    style={{ width: '100%', height: '300px' }}
                    className="w-100"
                    option={growOption}
                  />
                </Col>
              </Row>
            </Container>
            <Container className="section2">
              <Row className="mx-2">
                <FanGrowth
                  data={currentCompanyData}
                  title="粉絲成長指標"
                  brandArr={brandArr}
                />
              </Row>
            </Container>
            <Container className="section3">
              <Row className="mx-2">
                <AITeacher data={currentCompanyData} title="AI 導師建議" />
              </Row>
            </Container>
          </Col>
        )}
      </main>
    </>
  )
}

export default GroupFans
